import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
// import NProgress from 'nprogress';

import { authStore } from '@/store/global-stores';

import { authApi } from '@/utilities/axios';
import { showToast } from '@/utilities/toast-handler';
import { formatDisplayDate } from '@/utilities/date-formatter';

const PERMISSION_URL = process.env.VUE_APP_API_VERSION + '/admin/permissions';

export const usePermissionStore = defineStore('permission', () => {
    const productDetails = computed(() => {
        return authStore.getProductDetails;
    });
    // states
    const permissions = ref([]);
    const params = ref({
        page_size: null,
        page: null,
        product: null,
        code_desc: null,
    });
    const totalRecords = ref(null);
    const loading = ref(false);

    // this will filter out all the permissions which are applicable on the active selected product
    const allPermissions = computed(() => {
        return permissions.value
            ?.filter((permission) => {
                // contains the array of products [id], where permissions are applicable
                const permissionProducts = permission.permission_product?.map((product) => product.id);
                // now check if the permissionProducts array consist the active productDetails id and return accordingly
                return permissionProducts.includes(productDetails.value?.id);
            })
            ?.map((permission) => {
                return {
                    ...permission,
                    created_at: formatDisplayDate(permission.created_at),
                };
            });
    });

    const fetchAllPermissions = async (params, paginate = false) => {
        try {
            loading.value = true;
            const response = await authApi.get(PERMISSION_URL, {
                params: {
                    ...params,
                    paginate: paginate,
                },
            });
            if (response.statusCode === 200) {
                permissions.value = paginate ? response.data?.data : response.data;
                totalRecords.value = paginate ? response.data?.total : response.data?.length;
            }
        } catch (error) {
            showToast({}, error?.data?.message ?? 'Failed to fetch all permissions');
        } finally {
            loading.value = false;
        }
    };

    return {
        params,
        totalRecords,
        loading,
        // state
        allPermissions,
        // permissions,
        // methods
        fetchAllPermissions,
    };
});
